var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerSa = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.005 15L40.005 15",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 102L110 58C110 55.7909 106.418 54 102 54L66 54C61.5817 54 58 55.7909 58 58L58 102C58 104.209 61.5817 106 66 106L102 106C106.418 106 110 104.209 110 102Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198 102L198 58C198 55.7909 194.418 54 190 54L154 54C149.582 54 146 55.7909 146 58L146 102C146 104.209 149.582 106 154 106L190 106C194.418 106 198 104.209 198 102Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110 199.111L110 152.889C110 151.293 106.418 150 102 150L66 150C61.5817 150 58 151.293 58 152.889L58 199.111C58 200.707 61.5817 202 66 202L102 202C106.418 202 110 200.707 110 199.111Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198 199.111L198 152.889C198 151.293 194.418 150 190 150L154 150C149.582 150 146 151.293 146 152.889L146 199.111C146 200.707 149.582 202 154 202L190 202C194.418 202 198 200.707 198 199.111Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.005 240L40.005 240",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerSa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ver-sa.b41665571f617a5855c263211e56095c.svg";